import { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteItem,
  fetchPaginationData,
  updateStatus,
} from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import {
  DeleteSingleButton,
  ViewButton,
  ToggleSwitch,
} from "../../Components/TableHelper";
import { formatDate } from "../../utils/constant";
import TableSearch from "../../Components/TableSearch";
import PerPageSelect from "../../Components/PerPageSelect";
import { useDebounce } from "../../hooks/useDebounce";

const Customers = () => {
   const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const navigator = useNavigate();

  const fetchDataPagination = async (
    page = 1,
    currentSearch = search,
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
    };
    await fetchPaginationData(
      "adminCustomer/getAllCustomers",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
    );
  };

  useEffect(() => {
     const page = location.state?.currentPage || 1;
  const perPage = location.state?.perPage || 10;
    setCurrentPage(page);
  setPerPage(perPage);
    fetchDataPagination(page, "", perPage);
  }, []);

  const debouncedFetch = useDebounce((searchValue) => {
    fetchDataPagination(1, searchValue);
  }, 500);

  const handleSearchChange = (value) => {
    setSearch(value);
    debouncedFetch(value);
  };

  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, search, value);
  };

  const totalPages = Math.ceil(totalCount / perPage);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "adminCustomer/deleteCustomer",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleRedirect = (item) => {
    navigator("/customer-details", {
    state: {
      ...item,
      currentPage,
      perPage,
    },
  });
  };

  const handleStatusToggle = async (item) => {
    const updated = await updateStatus(item?._id, "customer", !item?.isActive);
    if (!updated) return;
    setdata((prev) =>
      prev.map((curr) =>
        curr._id === updated._id
          ? { ...curr, isActive: updated.isActive }
          : curr,
      ),
    );
  };

  const Tableheader = [
    "First Name",
    "Last Name",
    "Orders",
    "Email",
    "Status",
    "Created Date",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Customers", path: "/customers" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Customers</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <PerPageSelect value={perPage} onChange={handlePerPageChange} />
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <TableSearch
              value={search}
              onChange={handleSearchChange}
              placeholder="Search by name or email..."
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="custom-table table table-striped"
                    id="customertable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold" key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{item.firstName || "-"}</td>
                            <td>{item.lastName || "-"}</td>
                            <td>{item.orderCount}</td>
                            <td
                              style={{
                                maxWidth: "200px",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.email || "-"}
                            </td>
                            <td>
                              <ToggleSwitch
                                data={item}
                                name="isActive"
                                checked={item.isActive}
                                handleStatusToggle={handleStatusToggle}
                                module={"Customer"}
                              />
                            </td>
                            <td>{formatDate(item.createdAt)}</td>
                            <td>
                              <div className="d-flex" style={{ gap: "10px" }}>
                                <ViewButton
                                  handleRedirect={handleRedirect}
                                  item={item}
                                />
                                <DeleteSingleButton
                                  handleDelete={handleDelete}
                                  item={item}
                                />
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <h5>No data found</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="Customer"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default Customers;
